"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";

export const MobileShopNavTab = ({
  href,
  children,
  label,
  mobileLabel,
}: {
  href: string;
  label: string;
  mobileLabel?: string;
  children?: React.ReactNode;
}) => {
  const pathname = usePathname();

  return (
    <div
      className={cn(
        "flex h-full grow items-center justify-center gap-2 px-4 text-sm",
        pathname === href && "bg-orange-50 text-orange-700",
      )}
    >
      {children}
      <span className="hidden text-sm opacity-50 md:block">{label}</span>
      {/* <span className="block text-sm md:hidden opacity-50">{mobileLabel}</span> */}
    </div>
  );
};
